import React, { useState, useEffect } from 'react';

// import Theme from './theme';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/common/contact-bar.json`;

    const [content, setContent] = useState({
        office: {
            name: 'Office',
            address: 'R-406, 4th Floor, Block 3',
            phone: '+91 612 3028009'
        },
        lab: {
            name: 'Blockchain &amp; Robotics (PLANR) Lab',
            address: 'R-502, 5th Floor, Block 3',
            phone: '+91 612 3028889'
        }
    });

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div className="row contact">
            <div className="col-sm-12 contact-box">
                <h6>{content.office.name}</h6>
                <p>
                    <i className="fas fa-map-marked-alt" /> {content.office.address}
                </p>
                <p>
                    <i className="fas fa-phone-alt" /> {content.office.phone}
                </p>
            </div>

            {/* <div className="col-sm-12">
                <Theme />
            </div> */}
            <div>
                <hr />
            </div>

            <div className="col-sm-12  contact-box">
                <h6>{content.lab.name}</h6>
                <p>
                    <i className="fas fa-map-marked-alt" /> {content.lab.address}
                </p>
                <p>
                    <i className="fas fa-phone-alt" /> {content.lab.phone}
                </p>
            </div>
        </div>
    );
};

export default Component;
